<template>
  <div class="d-none">
    <b-modal v-model="showModal" centered hide-header hide-footer>
      <div class="modal-header">
        <h4 class="mb-0">ยืนยันแลกของสมนาคุณ</h4>
        <button type="button" aria-label="Close" class="close" @click="hide">
          ×
        </button>
      </div>
      <div>
        ต้องการใช้ {{ product.point_used | numeral("0,0") }} คะแนน เพื่อแลก
        {{ product.product_name }} สำหรับคุณ {{ customer.first_name_th }}
        {{ customer.last_name_th }} โดยมารับที่สาขา
        {{ customer.branch_name }} หรือไม่?
      </div>
      <div class="mt-3">
        <b-button
          class="btn-modal radius-btn"
          block
          variant="secondary"
          @click="confirm"
          >ยืนยัน</b-button
        >
        <b-button
          class="btn-modal radius-btn"
          block
          variant="outline"
          @click="hide"
          >ยกเลิก</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    product: {
      required: false,
      type: Object,
    },
    customer: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapGetters({ branchId: "getBranchId" }),
  },
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    async confirm() {
      let body = {
        user_guid: this.customer.user_guid,
        branch_id: this.branchId,
        redeem_id: this.product.redeem_id,
        product_id: this.product.product_id,
        redeem_type_id: this.product.product_type,
        create_user_id: this.$cookies.get("user_guid"),
      };

      await this.axios
        .post(`${this.$baseUrl}/redeem/redeem_item`, body)
        .then((data) => {
          if (data.result == 1) {
            this.$router
              .push({ path: `/redeem/history/${this.customer.member_id}` })
              .catch(() => {});
          } else {
            this.warningAlert(data.message);
          }
        });
    },
  },
};
</script>

<style scoped>
.modal-header {
  border-bottom: 0 !important;
  margin: 0px;
  padding: 0px;
  padding-bottom: 0.25rem;
}

::v-deep .modal-body {
  color: var(--primary-color);
  padding: 15px !important;
}
.btn-outline {
  border-color: var(--primary-color) !important;
  background-color: transparent !important;
  color: var(--primary-color) !important;
}
</style>
